export const conversionKeys = {
  amount: 'Amount',
  unit: 'Unit',
}
